export default __webpack_public_path__ + "static/media/backgroundmobile.f6b59471.png";